module.exports = __webpack_public_path__ + "img/user-interface-menu-profile-pic.9bacc7a0.png";